// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"info_section_infoContainer__2WkCF","button":"info_section_button__16Yqy"};